import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース取引判定(税務) */
enum LeaseTransactionJudgementTax {
  finance = '1',
  operating = '2',
}

const nameConfig = {
  finance: new Map([[Locale.ja, 'ファイナンス']]),
  operating: new Map([[Locale.ja, 'オペレーティング']]),
};

const toEnum = rawValueToEnum(LeaseTransactionJudgementTax, LeaseTransactionJudgementTax.finance);
const toDisplay = enumToName(LeaseTransactionJudgementTax, nameConfig);
const toDisplayWithPrefix = enumToName(LeaseTransactionJudgementTax, nameConfig, { prefix: true });

export const leaseTransactionJudgementTax = {
  enum: LeaseTransactionJudgementTax,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LeaseTransactionJudgementTax };
